import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox, ControlLabel } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
            day: '',
            hour: '',
            source: null,
            affid: null,
            country: null,
            groupBy: {},
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillUpdate(nextProps) {
        console.log(nextProps);
        if(this.props.type !== nextProps.type) {
            this.setState({ dateFrom: '', dateTo: '', day: '', hour: ''})
        }
    }

    handleFormSubmit() {
        const isValid = this.validateForm();
        const filters = { ...this.state };
        filters.groupBy = Object.keys(filters.groupBy);

        if(isValid) this.props.onSubmit(filters);
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    validateForm() {
        const { day, dateFrom, dateTo } = this.state;

        let alert = null;

        if(!day && !(dateFrom && dateTo)) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    getDateInputs() {
        let inputs = [];

        if(this.props.type === 'hourly') {
            inputs.push(<Col lg={4}>
                <FieldGroup
                    type="date"
                    name="day"
                    label="Day:"
                    onChange={this.handleFieldChange}
                    value={this.state.day}
                />
            </Col>);
            inputs.push(                    <Col lg={4}>
                <FieldGroup
                    type="number"
                    name="hour"
                    label="Hour:"
                    min={0}
                    max={23}
                    onChange={this.handleFieldChange}
                    value={this.state.hour}
                />
            </Col>)
        }
        else {
            inputs.push(<Col lg={4}>
                <FieldGroup
                    type="date"
                    name="dateFrom"
                    label="Date From:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateFrom}
                />
            </Col>);
            inputs.push(<Col lg={4}>
                <FieldGroup
                    type="date"
                    name="dateTo"
                    label="Date To:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateTo}
                />
            </Col>);
        }

        return inputs;
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="date">Date</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source">Source</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="affid">Affid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                    </Col>
                    {this.getDateInputs()}
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affids}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit()}>Load</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/components/Form/index.js